export const environment = {
  production: false,
  api: 'https://dev.api.sequenza.be/',
  dbName: 'be_sequenza',
};